import * as React from "react";
import { RenderAttributionTextHTML } from "components/utility/MediaAttributionUtil";
import { TrackedLink } from "src/components/utility/analytics/TrackedLink";
import { useLocalization } from "@shared-ui/localization-context";

export const renderTopCitiesAttributionTextHTML: RenderAttributionTextHTML = ({ mainText, altText, attribUrl }) => {
  const { formatText } = useLocalization();

  return (
    <div className="uitk-type-100 attributionText truncate" title={altText}>
      <TrackedLink
        title={formatText("hero.attribution.openLink", altText)}
        className="uitk-attribution-link"
        moduleName="attributionsText.ownerLink"
        href={attribUrl}
        rfrr="Attributions"
      >
        <div>
          <small dangerouslySetInnerHTML={{ __html: mainText }} />
        </div>
      </TrackedLink>
    </div>
  );
};
